module.exports = __webpack_public_path__ + "static/media/nov-2020.8df6c958.svg";